// src/utils/dateUtils.js
// 78차: UTC 날짜 계산 버그 전수조사 — new Date().toISOString().slice(0,10)로 "오늘"을
// 구하는 패턴이 이 세션에서만 40곳 넘게 발견됨. toISOString()은 항상 UTC라서, 클라이언트
// 기기가 한국 시간대(KST, UTC+9)일 때 자정~오전9시 사이엔 실제 오늘보다 하루 이른 날짜가
// 나옴 — "이번 달 매출", "오늘 예약", "어제 대비" 같은 계산이 이 시간대에 전부 하루씩
// 밀리는 원인이었음. 이 파일의 함수는 전부 기기의 로컬 시간(=사용자가 보는 시계) 기준으로
// 계산한다 — new Date().toISOString().slice(...)로 "오늘"/"이번 달"을 구하는 코드를
// 새로 짜지 말고 반드시 이 파일의 함수를 쓸 것.
export function todayStr() {
  return toLocalYMD(new Date());
}

export function thisMonthStr() {
  return todayStr().slice(0, 7);
}

export function toLocalYMD(date) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}

// "오늘"로부터 N일 전/후(음수 가능)의 로컬 YYYY-MM-DD
export function addDaysStr(days) {
  const d = new Date();
  d.setDate(d.getDate() + days);
  return toLocalYMD(d);
}

// 78차: 매장별 "예약 오픈 기간"(reservationWindowDays)이 자정이 아니라 특정 시각에
// 갱신되는 경우를 위함 — 예: "오늘로부터 7일 후 22시부터 다음 예약 가능"이면
// windowDays=7, openTime='22:00'. 오늘의 오픈 시각이 아직 안 지났으면 아직 그날의
// "다음 날짜 오픈"이 실행되지 않은 것이므로 실질 기간을 하루 적게 돌려준다.
// windowDays가 null(무제한)이면 그대로 null 반환.
export function effectiveWindowDays(windowDays, openTime) {
  if (windowDays == null) return null;
  if (!openTime) return windowDays;
  const [oh, om] = String(openTime).split(':').map(Number);
  if (Number.isNaN(oh)) return windowDays;
  const openMoment = new Date();
  openMoment.setHours(oh, om || 0, 0, 0);
  return new Date() < openMoment ? Math.max(0, windowDays - 1) : windowDays;
}

// 78차: 엑셀 일괄등록에서 "시작시간"/"종료시간" 셀을 시간 서식(h:mm)으로 입력하면 xlsx가
// "12:00" 문자열 대신 그 서식의 실제 저장값(하루 대비 비율, 0~1 사이 소수)을 그대로
// 돌려주는 버그가 78차62차에 발견돼 엑셀 파싱 지점(SuperAdminStoresScreen.js)엔 이미
// 보정이 있었는데, 그때 이미 잘못 저장된 매장(넥스트에디션)의 startTime/endTime이 여전히
// 소수로 남아있어서 그 매장 테마 전체의 예약 가능 시간이 통째로 비어버리는 사고로
// 이어졌음(전수조사가 아니라 실사용 중 발견) — 앞으로 같은 오염이 다시 들어와도 예약
// 화면이 조용히 깨지지 않도록, 시간 필드를 실제로 소비하는 지점(고객 화면의
// productService.flattenStoreThemes, 매장관리자 화면의 ScheduleTab)에서 공통 방어.
// 80차 후속: 19금 테마 나이 게이트 — "만 나이"(생일 지났는지까지 반영한 실제 나이).
// birthStr 형식은 EditProfileScreen.js가 저장하는 "YYYY-MM-DD". 값이 없거나 파싱
// 실패하면 null(나이 불명 — 호출부가 "확인 불가=차단"으로 처리할 것).
// ⚠️ functions/index.js에도 동일 로직이 있으니(서버측 검증) 여기를 고치면 같이 고칠 것.
// 80차 후속: [버그 수정, fork로 발견] 서버(isAdultBirthServer)는 KST로 고정 보정해서
// "오늘"을 구하는데, 이 클라이언트 버전은 기기 로컬 시간대를 그대로 썼음 — 기기 시간대가
// KST가 아니면(해외 로밍 등) 생일 당일 몇 시간 창에서 클라/서버 판정이 어긋날 수 있었음
// (서버가 항상 최종 재검증하므로 실제 우회는 불가능했지만, 부당한 클라 오차단 가능성 있는
// 순수 UX 결함) — 서버와 동일한 KST 보정 적용.
export function calcAge(birthStr) {
  if (!birthStr) return null;
  const [y, m, d] = String(birthStr).split('-').map(Number);
  if (!y || !m || !d) return null;
  const today = new Date(Date.now() + 9 * 60 * 60 * 1000); // KST 기준 오늘
  let age = today.getUTCFullYear() - y;
  if (today.getUTCMonth() + 1 < m || (today.getUTCMonth() + 1 === m && today.getUTCDate() < d)) age--;
  return age;
}

export function isAdultBirth(birthStr) {
  const age = calcAge(birthStr);
  return age !== null && age >= 19;
}

// 80차 후속: "확인된 미성년자"만 판정 — isAdultBirth()와 반대 방향의 안전 기본값이다.
// 예약/모집 차단(isAdultBirth)은 "모르면 차단"이 안전하지만, 이건 목록에서 19금
// 테마·모집글을 숨기는 용도라 "모르면(비회원·생년월일 미등록) 그대로 노출"이 맞다 —
// 안 그러면 아직 생년월일을 안 채운 실제 성인 손님까지 목록에서 콘텐츠가 사라져
// 전환을 해치고, 어차피 예약 시점엔 isAdultBirth 기준으로 별도로 다시 차단된다.
export function isConfirmedMinorBirth(birthStr) {
  const age = calcAge(birthStr);
  return age !== null && age < 19;
}

export function normalizeTimeStr(val) {
  // 78차: 실제 오염 데이터를 뜯어보니 숫자(number)가 아니라 "0.451..." 형태의 문자열로
  // 저장돼 있었음 — xlsx가 셀을 문자열로 내보내는 경로도 있는 것으로 보임. 순수 소수
  // 형태의 문자열도 같이 잡아냄("12:00"처럼 콜론이 있는 정상 문자열은 Number()가
  // NaN을 반환하므로 오염되지 않음).
  const num = typeof val === 'number' ? val : (typeof val === 'string' && val.trim() !== '' ? Number(val) : NaN);
  if (Number.isFinite(num) && num >= 0 && num < 1) {
    const totalMin = Math.round(num * 24 * 60);
    const hh = Math.floor(totalMin / 60) % 24;
    const mm = totalMin % 60;
    return `${String(hh).padStart(2, '0')}:${String(mm).padStart(2, '0')}`;
  }
  return val;
}
